/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Day_ThursdayInputs */

const en_coach_day_thursday = /** @type {(inputs: Coach_Day_ThursdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thursday`)
};

const de_coach_day_thursday = /** @type {(inputs: Coach_Day_ThursdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnerstag`)
};

/**
* | output |
* | --- |
* | "Thursday" |
*
* @param {Coach_Day_ThursdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_day_thursday = /** @type {((inputs?: Coach_Day_ThursdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Day_ThursdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_day_thursday(inputs)
	return de_coach_day_thursday(inputs)
});